import * as React from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';

const Tooltip = TooltipPrimitive.Root;

const TooltipProvider = TooltipPrimitive.Provider;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & { container?: React.RefObject<HTMLElement> }
>(({ className, container, ...props }, _ref) => {
  return (
    <TooltipPrimitive.Portal container={container?.current}>
      <TooltipPrimitive.Content {...props} />
    </TooltipPrimitive.Portal>
  );
});

const TooltipArrow = TooltipPrimitive.Arrow;

// biome-ignore lint/style/useComponentExportOnlyModules: UI library module export pattern
export { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger, TooltipArrow };
